import { render, staticRenderFns } from "./SupportTicketCardList.vue?vue&type=template&id=55baa41c&scoped=true"
import script from "./SupportTicketCardList.vue?vue&type=script&lang=js"
export * from "./SupportTicketCardList.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketCardList.vue?vue&type=style&index=0&id=55baa41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55baa41c",
  null
  
)

export default component.exports